var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconInjury(_a) {
    var size = _a.size, colorVariant = _a.colorVariant, onClick = _a.onClick, icon = _a.icon, theme = _a.theme, additionalProps = __rest(_a, ["size", "colorVariant", "onClick", "icon", "theme"]);
    var iconTheme = useContext(ThemeContext);
    var color = setColor(iconTheme, colorVariant, 'primary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", __assign({}, additionalProps, { width: renderSize, height: renderSize, viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM10.75 10.5C10.75 10.6381 10.6381 10.75 10.5 10.75H7.25C7.11193 10.75 7 10.8619 7 11V13C7 13.1381 7.11193 13.25 7.25 13.25H10.5C10.6381 13.25 10.75 13.3619 10.75 13.5V16.75C10.75 16.8881 10.8619 17 11 17H13C13.1381 17 13.25 16.8881 13.25 16.75V13.5C13.25 13.3619 13.3619 13.25 13.5 13.25H16.75C16.8881 13.25 17 13.1381 17 13V11C17 10.8619 16.8881 10.75 16.75 10.75H13.5C13.3619 10.75 13.25 10.6381 13.25 10.5V7.25C13.25 7.11193 13.1381 7 13 7H11C10.8619 7 10.75 7.11193 10.75 7.25V10.5Z", fill: color })));
}
//# sourceMappingURL=icon.injury.component.js.map